import { useState } from "react";
import { LoginForm } from "@/components/auth/LoginForm";
import { RegisterForm } from "@/components/auth/RegisterForm";
import { CatFace } from "@/components/yarn/Cat";
import { YarnBall } from "@/components/yarn/YarnBall";

const STEPS = [
  ["Write", "Everyone gets a timer to add the next line.", "cat-write"],
  ["Vote", "Pick the best line. Never your own.", "cat-vote-x"],
  ["Weave", "The winner's cat grabs the yarn and stitches it in.", "cat-weave-q"],
];

function Hero() {
  return (
    <div className="rise-in">
      <div className="flex items-center gap-3">
        <YarnBall size={60} className="yarn-bob" />
        <span className="font-display text-3xl font-semibold text-[var(--yarn-terracotta)]" data-testid="brand-name">Yarn</span>
      </div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] mt-6">
        Spin a story together, one line at a time.
      </h1>
      <p className="mt-5 text-sm sm:text-base text-[var(--yarn-muted)] max-w-md">
        AI writes the first line. Your friends write what happens next, vote for the best, and the story keeps going until you say stop.
      </p>
      <ol className="mt-8 hidden sm:grid gap-3 max-w-md">
        {STEPS.map(([title, text, catId], i) => (
          <li key={title} className="flex items-center gap-4 rise-in" style={{ animationDelay: `${150 + i * 90}ms` }}>
            <CatFace id={catId} size={40} withYarn />
            <div>
              <p className="font-display font-semibold">{title}</p>
              <p className="text-sm text-[var(--yarn-muted)]">{text}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default function AuthPage() {
  const [mode, setMode] = useState("signup");
  return (
    <div className="flex-1 flex items-center">
      <div className="max-w-6xl mx-auto w-full px-5 sm:px-8 py-10 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <Hero />
        <div className="patch patch-stitched p-6 sm:p-9 rise-in" style={{ animationDelay: "120ms" }}>
          <div className="flex gap-2 mb-6" role="tablist">
            {[["signup", "Sign up"], ["login", "Log in"]].map(([key, label]) => (
              <button key={key} role="tab" aria-selected={mode === key} data-active={mode === key}
                onClick={() => setMode(key)} className="chip h-11 px-5" data-testid={`auth-tab-${key}`}>
                {label}
              </button>
            ))}
          </div>
          {mode === "login" ? <LoginForm /> : <RegisterForm />}
        </div>
      </div>
    </div>
  );
}
